import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Input, Flex, Skeleton, Typography } from 'antd';
import { useSelector } from 'react-redux';
import styles from './lead-history-modal.module.scss';
import { NoteCard } from '.';

const { TextArea } = Input;

export const LeadHistoryModal = ({ notesHook, open, onClose }) => {
  const { selectedLead } = useSelector((state) => state.spot);
  const [newNote, setNewNote] = useState('');

  const { fullNotes, createNode, loading } = notesHook;

  const handleAddNote = async () => {
    if (newNote.trim()) {
      await createNode({ leadId: selectedLead.id, note: newNote });
      setNewNote('');
    }
  };

  const leadName = selectedLead ? `${selectedLead.parent_first_name} ${selectedLead.parent_last_name}` : '';

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={800}
      className={styles.leadHistoryModal}
      title={`Lead History - ${leadName} - ID: ${selectedLead?.id}`}
      centered>
      <Flex vertical>
        <div className={styles.addNoteSection}>
          <Flex gap="middle" align="flex-start">
            <TextArea
              placeholder="Add a new note..."
              value={newNote}
              onChange={(e) => setNewNote(e.target.value)}
              className={styles.noteTextarea}
              rows={6}
            />
            <Button type="primary" loading={loading} onClick={handleAddNote} className={styles.addNoteButton}>
              Add Note
            </Button>
          </Flex>
        </div>

        <Flex vertical gap={16}>
          {loading ? (
            <Skeleton />
          ) : fullNotes?.length > 0 ? (
            fullNotes?.map((note) => <NoteCard key={note.id} note={note} />)
          ) : (
            <Typography.Text>No Interaction Histoy Yet.</Typography.Text>
          )}
        </Flex>
      </Flex>
    </Modal>
  );
};

LeadHistoryModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
